import { LvgAssetHeader } from 'components/Organisms/MainGames/Leverage/LvgGameHeader/LvgYoloGameHeader/LvgAssetHeader'

export const YolobotGraphHeader = ({ assetInfo }) => {
  return !!assetInfo && <LvgAssetHeader assetInfo={assetInfo} noSelector />
}
